import {AppEventSymbol, BroadcastEventSymbol} from './symbols';
import {Constructor, EventOptions} from './types';

const hashCode = (s: string) => s.split('').reduce((a, b) => (((a << 5) - a) + b.charCodeAt(0)) | 0, 0);

export function AppEvent<T>(options?: EventOptions) {
	return function (ctr: Constructor<T>) {
		if (options?.broadcast) {
			ctr.prototype[BroadcastEventSymbol] = {
				eventID: hashCode(ctr.prototype.constructor.toString()),
			};
		} else {
			ctr.prototype[AppEventSymbol] = true;
		}
	};
}
